import axionIns from "../axios";

const getTodolist = async (page, perPage, search, selectedUser) => {
    return axionIns.get(`admin/todo?page=${page}&perPage=${perPage ? perPage : 10}`).then((response) => { return response.data });
};


const addTodo = (payload, selectedUser) => {
    return axionIns.post(`admin/todo/${selectedUser}`, payload).then((response) => {
        return response.data;
    });
};

export default {
    getTodolist,
    addTodo
};
